import { parse } from 'query-string';
import { captureError } from '../errors';

export function encodeRedirect() {
  const url = parse(window.location.search)?.redirect as string || '';
  let nextBase64 = '';
  if (url) {
    try {
      nextBase64 = atob(url);
    } catch (e) {
      captureError('url.encodeRedirect');
    }
  }
  return nextBase64;
}

export function getRedirect() {
  return window.location.search || '';
}
